import React, { useEffect, useState, Suspense, lazy } from "react";
import { Link } from "react-router-dom";
import { IoPhonePortraitSharp } from "react-icons/io5";
import { MdPhoneAndroid } from "react-icons/md";
import { RiAppleFill } from "react-icons/ri";
import { BiLaptop } from "react-icons/bi";

import dashboardImg from "@/assets/banner/waggex-payroll-software-dashboard.png";
import dashboardImg700 from "@/assets/banner/Hero-Banner-721.png";
import dashboardImg412 from "@/assets/banner/Hero-Banner-412.png";
import heroImg from "@/assets/waggex/hrms-payroll-software-india-dashboard-hero.webp?w=350&format=webp&quality=75";
import heroImgdesktop from "@/assets/waggex/hrms-payroll-software-india-dashboard-hero.webp?w=550&format=webp&quality=75";
// import Services from "../components/Service";
import { Helmet } from "react-helmet-async";
import StatsSection from "../components/common/StatsSection";
import { Check } from "lucide-react";
// import { TypeAnimation } from "react-type-animation";
import { useHrmsCounts } from "../hooks/useHrmsCounts";
import { useInView } from "react-intersection-observer";
import MainHeroSection from "../components/MainHeroSection";
import { LuCreditCard, LuFileText, LuUsers } from "react-icons/lu";
import { useForm } from "react-hook-form";
import { FiMail, FiPhone, FiUser, FiUsers } from "react-icons/fi";
const Services = lazy(() => import("../components/Service"));
const OurFeature = lazy(() => import("../components/OurFeature"));
// import PayPage from "../components/PayPage";
const PayPage = lazy(() => import("../components/PayPage"));
const AppDownloadCard = lazy(
  () => import("../components/common/AppDownloadCard"),
);

const CustomerReviews = lazy(
  () => import("../components/payrolewebapp/CustomerReviews"),
);

const ComparisonTable = lazy(
  () => import("../components/payrolewebapp/ComparisonTable"),
);

const HomeFaq = lazy(() => import("./HomeFaq"));

const PayrollBanner = lazy(() => import("../components/common/PayrollBanner"));

const ModernizeHR = lazy(() => import("../components/common/ModernizeHR"));
const faq1 = [
  {
    title: "Is My Data Secure With The Waggex Payroll Web App?",
    content:
      "Yes. Waggex uses enterprise-grade encryption and secure cloud infrastructure to protect all payroll, attendance, and employee data. Access is role-based, meaning only authorised users within your organisation can view or modify sensitive records.",
  },
  {
    title: "Does Waggex Comply With Data Security Standards?",
    content:
      "Yes. The Waggex platform complies with Indian data security standards and stores all records on encrypted servers. Your payroll, attendance, and employee information is never shared with third parties.",
  },
];
const faq2 = [
  {
    title: "Can I Create More Than One Company On Waggex?",
    content:
      "Yes. Waggex supports multi-company management under a single account, making it ideal for HR consultants, group companies, and businesses operating across multiple legal entities or locations.",
  },
  {
    title: "How Does Multi-Company Management Work In Waggex?",
    content:
      "Multiple business profiles can be created within one Waggex account, each with independent payroll settings, attendance policies, employee records, and compliance configurations.",
  },
];
const features = [
  {
    number: "01",
    title: "Attendance-based payroll processing",
  },
  {
    number: "02",
    title: "PF, ESI, TDS and statutory records",
  },
  {
    number: "03",
    title: "Employee apps for self-service",
  },
  {
    number: "04",
    title: "AI FaceLens attendance option",
  },
];
const steps = [
  {
    title: "Company Setup",
  },
  {
    title: "Employee Onboarding",
  },
  {
    title: "Attendance Management",
  },
  {
    title: "Payroll & Payslips",
  },
];

const schema = [
  // SCHEMA 1: SoftwareApplication
  {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    name: "Waggex HRMS & Payroll Software",
    applicationCategory: "BusinessApplication",
    operatingSystem: "Web, Android, iOS",
    description:
      "Waggex is an HRMS and payroll platform for Indian businesses automating payroll, attendance, leave, compliance, and workforce management.",

    url: "https://www.waggex.com/",

    featureList: [
      "HRMS software India",
      "Payroll software India",
      "Attendance management software India",
      "Leave management software India",
      "Field employee tracking software India",
    ],

    offers: {
      "@type": "Offer",
      price: "0",
      priceCurrency: "INR",
    },

    aggregateRating: {
      "@type": "AggregateRating",
      ratingValue: "4.8",
      ratingCount: "412",
      bestRating: "5",
      worstRating: "1",
    },
  },

  // SCHEMA 2: FAQPage
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "What is Waggex HRMS & Payroll Software?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Waggex is an employee management platform that helps Indian businesses manage payroll, attendance, leave, compliance, and workforce operations from one HRMS dashboard.",
        },
      },
      {
        "@type": "Question",
        name: "Is Waggex suitable for small businesses in India?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Yes. Waggex is designed for startups, SMEs, and growing businesses that need a simple connected employee management solution without complex setup.",
        },
      },
      {
        "@type": "Question",
        name: "Can Waggex manage payroll and attendance together?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Yes. Payroll, attendance, leave, employee records, and compliance are all connected within one Waggex platform, eliminating manual data transfer between systems.",
        },
      },
      {
        "@type": "Question",
        name: "Does Waggex support field employee tracking?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Yes. Businesses can track field employees using live GPS location tracking and geo-location attendance features available in the Waggex platform.",
        },
      },
      {
        "@type": "Question",
        name: "Can employees use Waggex from mobile devices?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Yes. Employees can mark attendance, apply for leave, manage tasks, and access HR information through the Waggex mobile apps for Android and iOS.",
        },
      },
      {
        "@type": "Question",
        name: "Is Waggex suitable for businesses across India?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Yes. Waggex is built for Indian businesses and supports payroll compliance, statutory deductions, attendance management, and workforce operations across all Indian states.",
        },
      },
    ],
  },

  // SCHEMA 3: Organization
  {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "Waggex",
    url: "https://www.waggex.com/",
    logo: "https://www.waggex.com/waggex-payroll-software-logo.png",
    description:
      "Waggex provides HRMS and payroll software for Indian businesses.",
    areaServed: "IN",
    contactPoint: {
      "@type": "ContactPoint",
      contactType: "customer support",
      availableLanguage: ["English", "Hindi"],
    },
  },
];

function LazySection({ children, name }) {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0,
    rootMargin: "100px 0px",
  });

  return <div ref={ref}>{inView ? children : null}</div>;
}

export default function HomePage() {
  const { counts, loading } = useHrmsCounts();

  return (
    <>
      <Helmet>
        <title>
          Best Payroll & HRMS Software for Indian Businesses | Waggex
        </title>
        <meta
          name="description"
          content="Waggex helps Indian businesses automate payroll, attendance, leave, compliance, and workforce management from one connected HRMS platform. Start free today"
        />
        {/* <meta
          name="keywords"
          content="Payroll Software, Selfie based attendance, Live Location Tracking, Staff Attendance App, Payroll Management, Shift Management, Leave Management, Task Management, Geo-Location Attendance, Tax and Forms Management, Automated Payslips, Waggex"
        /> */}
        <link rel="canonical" href="https://www.waggex.com/" />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(schema),
          }}
        />
      </Helmet>
      <div className="w-full mx-auto">
        <MainHeroSection />
        <LazySection name="Stats" style={{ minHeight: 100 }}>
          <StatsSection counts={counts} loading={loading} source="home" />
          <Services />

          <section className="w-full bg-[#F6F9FB] px-6 py-10">
            <div className="max-w-6xl mx-auto">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
                {/* Left Content */}
                <div className="space-y-6 text-center lg:text-left">
                  <div className="mb-6 flex items-center gap-3">
                    <span className="w-17.5 h-0.5 rounded bg-linear-to-r from-[#10324F] via-[#607D8B] to-transparent shadow-[0_0_6px_rgba(16,50,79,0.15)]"></span>
                    <span className="text-sm font-medium uppercase tracking-wider text-[#10324F]">
                      All-in-One HRMS Software
                    </span>
                  </div>
                  <h2 className="text-[#10324F] text-xl sm:text-3xl font-roboto font-bold leading-snug">
                    Manage Everything From Employee Onboarding to Payroll
                    Processing
                  </h2>

                  <p className="selfie-service-list-item-text py-4">
                    Waggex combines payroll, attendance, compliance, leave
                    management, task tracking, and employee management into a
                    single HRMS platform. Manage office staff, field teams, and
                    remote employees without switching between tools
                  </p>

                  <button
                    onClick={() =>
                      (window.location.href = "https://app.waggex.com/signup")
                    }
                    className="mt-4 bg-[#10324F] text-white h-10 px-6 rounded-xl text-sm sm:text-xl shadow-lg hover:scale-[1.02] transition"
                  >
                    Create Free Account
                  </button>
                </div>

                {/* Right Cards */}
                <div className="space-y-2">
                  {steps.map((item, index) => {
                    return (
                      <div
                        key={index}
                        style={{
                          boxShadow: `
                                rgb(167 191 210 / 40%) -15px -15px 20px inset,
                                rgb(170 188 202 / 30%) -20px -20px 30px
                              `,
                        }}
                        className="flex gap-4 items-start justify-center bg-white border border-[#E5EDF5] rounded-2xl p-5 shadow-sm hover:shadow-md transition-all duration-300 max-w-sm mx-auto"
                      >
                        {/* Icon */}
                        <div className="flex items-center justify-center text-[#10324F]">
                          <Check size={30} aria-hidden="true" />
                        </div>

                        {/* Content */}
                        <div className="flex-1 text-left">
                          <h2 className="mt-1 text-[#10324F] font-semibold text-sm">
                            {item.title}
                          </h2>

                          {/* <p className="selfie-service-list-item-text mt-1">
                            {item.description}
                          </p> */}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </section>

          {/* <PayPage /> */}
        </LazySection>
        <LazySection name="Features" style={{ minHeight: 200 }}>
          <OurFeature />
        </LazySection>
        <section className="bg-[#FFFFFF] py-10 px-6 mt-10 mb-10">
          <div className="mx-auto max-w-6xl">
            <div className="grid gap-12 lg:grid-cols-2 lg:gap-16 items-center">
              {/* Left Content */}
              <div>
                <div className="mb-6 flex items-center gap-3">
                  <span className="w-17.5 h-0.5 rounded bg-linear-to-r from-[#10324F] via-[#607D8B] to-transparent shadow-[0_0_6px_rgba(16,50,79,0.15)]"></span>
                  <span className="text-sm font-medium uppercase tracking-wider text-[#10324F]">
                    Why Waggex
                  </span>
                </div>

                <h2 className="max-w-xl text-xl sm:text-3xl font-roboto font-bold leading-tight text-[#10324F]">
                  Built for Growing Indian Businesses
                </h2>

                <p className="mt-6 max-w-xl text-lg leading-8 text-[#10324F]">
                  Waggex simplifies payroll, attendance, and workforce
                  management for businesses that want fewer manual processes,
                  better accuracy, and complete visibility over employee
                  operations
                </p>
              </div>

              {/* Right Cards */}
              <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
                {features.map((item) => (
                  <div
                    key={item.number}
                    className={`rounded-2xl bg-white border-[#AEAEC014]  shadow-sm transition hover:shadow-md px-2 py-9
                        ${item.number === "02" ? "mb-10 sm:mb-0" : ""} ${
                          item.number === "01" || item.number === "03"
                            ? "relative -top-6.25"
                            : ""
                        }`}
                    style={{
                      boxShadow: `
                      rgb(167 191 210 / 40%) -15px -15px 20px inset,
                      rgb(170 188 202 / 30%) -20px -20px 30px 
                    `,
                    }}
                  >
                    <h2 className="text-3xl font-bold text-[#10324F]">
                      {item.number}
                    </h2>
                    <p className="mt-4 text-sm font-normal leading-tight text-[#10324F]">
                      {item.title}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>
        <Suspense fallback={null}>
          <CustomerReviews />
          <HomeFaq
            faq1={faq1}
            faq2={faq2}
            subtitle="Common questions from Indian businesses evaluating Waggex HRMS & Payroll Software"
          />
          <PayrollBanner
            heading="Everything Your HR Team Needs. One Platform"
            description="Manage payroll, attendance, compliance, employee records, and workforce operations with greater accuracy, visibility, and control"
            buttonText="Try Waggex Free | Book Demo"
          />
          <AppDownloadCard />
          <ModernizeHR />
        </Suspense>
      </div>
    </>
  );
}
